import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-common/src/async.tsx';
import {
	setPerformanceMarkLoadStart,
	setPerformanceMarkLoadEnd,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/performance-marks/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type CoreProjectSidebarType from './ui/index.tsx';

const LazyCoreProjectSidebar = lazyForPaint<typeof CoreProjectSidebarType>(() => {
	setPerformanceMarkLoadStart();
	return import(/* webpackChunkName: "async-sidebar-core" */ './ui/index.tsx').then((bundle) => {
		setPerformanceMarkLoadEnd();
		return bundle;
	});
});

// delete when cleaning up getWillShowNav4
const CoreProjectSidebar = () => (
	<SidebarBoundary id="coreProject">
		<LazyCoreProjectSidebar />
	</SidebarBoundary>
);

export default memo(CoreProjectSidebar);
